import { render } from "./PreferredShippingMethodList.vue?vue&type=template&id=7370c892"
import script from "./PreferredShippingMethodList.vue?vue&type=script&lang=js"
export * from "./PreferredShippingMethodList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__